import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { identificationType } from "../../../store/identificationType/actions";
export var useGetIdentificationType = function (trigger) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) { return ({
        responseIdentificationType: state.IdentificationType.responseIdentificationType,
        errorIdentificationType: state.IdentificationType.errorIdentificationType,
        loadingIdentificationType: state.IdentificationType.loadingIdentificationType,
    }); }), responseIdentificationType = _a.responseIdentificationType, errorIdentificationType = _a.errorIdentificationType, loadingIdentificationType = _a.loadingIdentificationType;
    useEffect(function () {
        if (trigger) {
            dispatch(identificationType({
                enable: true,
                page: 1,
                limit: 10,
            }));
        }
    }, [trigger]);
    return {
        responseIdentificationType: responseIdentificationType,
        errorIdentificationType: errorIdentificationType,
        loadingIdentificationType: loadingIdentificationType,
    };
};
